import i18n from '../i18n';

// Role names are translated through the i18n instance directly because
// this helper is called during render (from memberDetailsView), where the
// surrounding useTranslation() hook already re-renders on language change.
export const getPrivilegeString = (privileges) => {
    if (!privileges) return i18n.t('roles.member');
    const privilegeString = privileges
        .map((p) => privilegeSwitchCase(p))
        .join(', ');
    return privilegeString;
};

const privilegeSwitchCase = (privilege) => {
    switch (privilege) {
        case 'chairman':
            return i18n.t('roles.chairman');
        case 'vicechairman':
            return i18n.t('roles.vicechairman');
        case 'admin':
            return i18n.t('roles.admin');
        case 'boardmember':
            return i18n.t('roles.boardmember');
        case 'functionary':
            return i18n.t('roles.functionary');
        case 'tutor':
            return i18n.t('roles.tutor');
        case 'bachelorfresher':
            return i18n.t('roles.bachelorfresher');
        case 'masterfresher':
            return i18n.t('roles.masterfresher');
        case 'kiltisban':
            return i18n.t('roles.kiltisban');
        default:
            return '-';
    }
};
